export const PINCODE_MIN_LENGTH = 3;
export const PINCODE_MAX_LENGTH = 20;

/** Letters, numbers, spaces, and hyphens only. */
export const PINCODE_ALLOWED_CHAR = /^[A-Za-z0-9 -]$/;
export const PINCODE_ALLOWED_PATTERN = /^[A-Za-z0-9 -]+$/;

export const PINCODE_INVALID_CHAR_ERROR =
  "PIN code can only contain letters, numbers, spaces, and hyphens (-)";

const PINCODE_NAVIGATION_KEYS = new Set([
  "Backspace",
  "Delete",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown",
  "Tab",
  "Home",
  "End",
  "Enter",
  "Escape",
]);

export type PincodeValidationResult = {
  isValid: boolean;
  error: string;
};

export function sanitizeRecipientPincode(value?: string | null): string {
  return (value ?? "").replace(/[^A-Za-z0-9 -]/g, "").slice(0, PINCODE_MAX_LENGTH);
}

export function isAllowedPincodeKey(key: string, withModifier = false): boolean {
  if (withModifier) return true;
  if (PINCODE_NAVIGATION_KEYS.has(key)) return true;
  if (key.length !== 1) return true;
  return PINCODE_ALLOWED_CHAR.test(key);
}

export function hasInvalidPincodeCharacters(value?: string | null): boolean {
  const raw = value ?? "";
  return raw !== sanitizeRecipientPincode(raw);
}

export function validateRecipientPincode(pincode?: string | null): PincodeValidationResult {
  const pin = (pincode ?? "").trim();

  if (!pin) {
    return { isValid: false, error: "PIN code is required" };
  }

  if (pin.length < PINCODE_MIN_LENGTH || pin.length > PINCODE_MAX_LENGTH) {
    return {
      isValid: false,
      error: `PIN code must be between ${PINCODE_MIN_LENGTH} and ${PINCODE_MAX_LENGTH} characters`,
    };
  }

  if (!PINCODE_ALLOWED_PATTERN.test(pin)) {
    return {
      isValid: false,
      error: PINCODE_INVALID_CHAR_ERROR,
    };
  }

  return { isValid: true, error: "" };
}
